import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
  Container,
  Card,
  Grid,
  Box,
  Typography,
  CardContent,
  CardActions,
  Button,
  Breadcrumbs,
  Modal,
} from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import uploadService from "../../../services/upload";
import projectService from "../../../services/project";
import { instanceToken } from "../../../utils/constant";

const styleR = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Project = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [project, setProject] = useState(null);
  const [openR, setOpenR] = useState(false);

  useEffect(() => {
    if (!project) {
      fetchProject();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchProject = async () => {
    try {
      const res = await projectService.getProject(instanceToken.token, id);
      setProject(res.data);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };

  if (!project) {
    return <em>Loading...</em>;
  }

  const handleOpenR = () => setOpenR(true);
  const handleCloseR = () => {
    setOpenR(false);
  };

  const handleRemove = async () => {
    try {
      if (project.pictures) {
        let imageArray = project.pictures.split("||");
        imageArray = imageArray.map((image) =>
          image.substring(image.lastIndexOf("/") + 1)
        );
        await uploadService.deleteImages(instanceToken.token, {
          filenames: imageArray,
        });
      }
      await projectService.deleteProject(instanceToken.token, project.id);
      homeAlert("Project post have been removed.", false);
      navigate("/projects");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <>
      <div role="presentation">
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" to="/projects">
            Projects Post
          </Link>
          <Typography color="text.primary">Project (ID - {id})</Typography>
        </Breadcrumbs>
      </div>
      <Container
        maxWidth={false}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          mt: 2,
        }}
      >
        <Card
          sx={{
            minWidth: "70vw",
            display: "grid",
            gridTemplateColumns: "1fr 2fr",
          }}
        >
          <div>
            <ImageList
              sx={{ width: 500, height: 250 }}
              cols={3}
              rowHeight={164}
            >
              {project.pictures &&
                project.pictures.split("||").map((img, index) => (
                  <ImageListItem key={index}>
                    <img
                      src={`${img}?w=164&h=164&fit=crop&auto=format`}
                      srcSet={`${img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                      alt=""
                      loading="lazy"
                    />
                  </ImageListItem>
                ))}
            </ImageList>
            <CardContent sx={{ pr: 5 }}>
              <Grid sx={{ m: 2 }} container spacing={1}>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">
                    Title :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" color="text.secondary">
                    {project.title}
                  </Typography>
                </Grid>
              </Grid>
              <Grid sx={{ m: 2 }} container spacing={1}>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">
                    Title (Myanmar) :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" color="text.secondary">
                    {project.titleMm}
                  </Typography>
                </Grid>
              </Grid>
              <Grid sx={{ m: 2 }} container spacing={1}>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">
                    Topic :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" color="text.secondary">
                    {project.topic}
                  </Typography>
                </Grid>
              </Grid>
              <Grid sx={{ m: 2 }} container spacing={1}>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">
                    Topic (Myanmar) :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" color="text.secondary">
                    {project.topicMm}
                  </Typography>
                </Grid>
              </Grid>
              <Grid sx={{ m: 2 }} container spacing={1}>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">
                    Created On :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" color="text.secondary">
                    {project.createdAt.substring(0, 10)}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </div>
          <Box
            sx={{
              display: "flex",
            }}
          >
            <Box
              sx={{
                flex: 1,
                p: 2,
                bgcolor: "#f7f7f5",
                borderRadius: 2,
              }}
            >
              <div
                dangerouslySetInnerHTML={{ __html: project.description }}
              ></div>
            </Box>
            <Box
              sx={{
                ml: 1,
                flex: 1,
                p: 2,
                bgcolor: "#f7f7f5",
                borderRadius: 2,
              }}
            >
              <div
                dangerouslySetInnerHTML={{ __html: project.descriptionMm }}
              ></div>
            </Box>
          </Box>

          <CardActions sx={{ gridColumn: "1/3", justifyContent: "end" }}>
            <Button size="small" color="error" onClick={handleOpenR}>
              Remove
            </Button>
            <Button
              size="small"
              component={Link}
              to={`/updateProject/${project.id}`}
            >
              Edit
            </Button>
          </CardActions>
        </Card>
      </Container>
      <Modal
        keepMounted
        open={openR}
        onClose={handleCloseR}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={styleR}>
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
            Confirmation
          </Typography>
          <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
            Are you sure want to remove it?
          </Typography>
          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button color="secondary" onClick={handleCloseR}>
              Cancel
            </Button>
            <Button onClick={handleRemove}>Confirm</Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Project;
